import { render, staticRenderFns } from "./User_Data_edit.vue?vue&type=template&id=8b1a10d8&scoped=true&"
import script from "./User_Data_edit.vue?vue&type=script&lang=js&"
export * from "./User_Data_edit.vue?vue&type=script&lang=js&"
import style0 from "./User_Data_edit.vue?vue&type=style&index=0&id=8b1a10d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1a10d8",
  null
  
)

export default component.exports